import React from "react"

import { BRANCH_LABEL, BranchKind } from "../../branchKind"
import {
  TerminalAddButtonContainer,
  TerminalAddButtonCircle,
  TerminalBranchLabel
} from "./TerminalAddButton.styled"

type Props = {
  onClick: () => void
  /** Horizontal offset in % from the node's left edge (e.g. "25%" for the
   *  condition's Then branch). */
  left?: string
  /** Optional branch label shown above the "+" — Then / Otherwise on condition
   *  branches. Mirrors the API's `then` / `otherwise` field names. */
  branchLabel?: BranchKind
  /** Highlight this "+" as an active drop target while a node is dragged over it. */
  highlighted?: boolean
}

const TerminalAddButton = ({
  onClick,
  left = "50%",
  branchLabel,
  highlighted = false
}: Props) => (
  <TerminalAddButtonContainer style={{ left }}>
    {branchLabel && (
      <TerminalBranchLabel $variant={branchLabel}>
        {BRANCH_LABEL[branchLabel]}
      </TerminalBranchLabel>
    )}
    <TerminalAddButtonCircle
      type="button"
      aria-label="Add node"
      className="nodrag nopan"
      $highlighted={highlighted}
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
    >
      +
    </TerminalAddButtonCircle>
  </TerminalAddButtonContainer>
)

export default TerminalAddButton
